unable to read source [project]/packages/analitica/src/plugins/datadog/index.ts